<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

withDefaults(defineProps<{ isCompany?: boolean }>(), {
  isCompany: false,
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['main-section-skeleton', { _mobile: isMobile }]">
    <Skeleton width="100%" height="202px" />
    <div v-if="isCompany" class="main-section-skeleton__workers">
      <Skeleton
        v-for="worker in 3"
        :key="worker"
        width="100%"
        :height="isMobile ? '250px' : '300px'"
        :max-width="isMobile ? '200px' : '100%'"
      />
    </div>
    <Skeleton width="100%" :height="isMobile ? '380px' : '400px'" />
  </div>
</template>

<style lang="less" scoped>
.main-section-skeleton {
  .flex-column(@size-x5);
  .box-shadow();

  padding: @size-x8;

  &__workers {
    display: flex;
    gap: @size-x3;
    align-items: center;
  }

  &._mobile {
    padding: @size-x5;
  }

  &._mobile &__workers {
    overflow-x: scroll;
  }
}
</style>
